import "./base.js";

class ManipulateCheckbox extends BaseManipulateInput {
  constructor(input) {
    super(input);
  }
  getValue() {
    return this.input.is(":checked");
  }

  setValue(value) {
    if (value) {
      this.input.prop("checked", "checked");
    } else {
      this.input.prop("checked", false);
    }
  }
}

window.ManipulateCheckbox = ManipulateCheckbox;
